import { lazy } from "react";
import { Navigate } from "react-router-dom";
// import City from "../components/route";

import RouteIcon from "@mui/icons-material/Route";

import AltRouteIcon from "@mui/icons-material/AltRoute";

const RouteEditView = lazy(() => import("../components/routeEditView"));
const RouteCreate = lazy(() => import("../components/route"));
const RouteList = lazy(() => import("../components/routeList"));

const userRoute = {
  icon: RouteIcon,
  name: "Route Management",
  link: "/route-management",
  path: "route-management",
  superAdminView: false,
  permission: "Routes-Read",
  index: 16,
  children: [
    {
      path: "routes",
      element: <RouteList />,
      permission: "Routes-Read",
      name: "Routes",
      index: 1,
      link: "route-management/routes",
      icon: AltRouteIcon,
    },
    {
      path: "routes/create",
      element: <RouteCreate />,
    },
    {
      path: "routes/:id",
      element: <RouteEditView />,
    },
    // {
    //   path: "transporter/view/:id",
    //   element: <TransporterView />,
    // },
    {
      path: "",
      element: <Navigate to="routes" replace />,
    },
  ],
};
export default userRoute;
